import * as React from 'react';

import { VoiceboxConversationContextValue } from 'bones/constants/voicebox/conversation';
import { asyncNoop } from 'bones/utils/noop';

export const VoiceboxConversationContext =
  React.createContext<VoiceboxConversationContextValue>({
    conversationId: '',
    id: null,
    isLoadingConversation: false,
    isLoadingInitialConversation: false,
    isLoadingFeedback: false,
    isLoadingMessage: false,
    isRefetchingConversation: false,
    loadingDownloadMessageId: '',
    messages: [],
    downloadCsv: asyncNoop as any,
    sendFeedback: asyncNoop as any,
    sendMessage: asyncNoop as any,
  });

export const useVoiceboxConversation = () => {
  return React.useContext(VoiceboxConversationContext);
};
